export const PurposeTemplate = ({ passionForm, peopleForm, impactForm, productForm }) => {
    return (
        <>
            <p className="p-3 font-bold border-b text-xl">Purpose</p>
            <div className="ml-16 border-l">
                <div>
                    <p className="p-3 font-bold border-b text-xl">Passion</p>
                    <span className="font-bold pl-3 pt-3">Things That Made You Proud:</span>
                    <ul className="p-3 border-dashed border-b">
                        {passionForm?.thingsThatMadeYouProud.map((el, index) => (
                            <li key={index}>{el.proud}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Emerged From Cases:</span>
                    <ul className="p-3 border-dashed border-b">
                        {passionForm?.emergedFromCases}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Emerged From Sentence:</span>
                    <ul className="p-3">
                        {passionForm?.emergedFromSentence}
                    </ul>
                </div>
                <div>
                    <p className="p-3 font-bold border-b border-t text-xl">People</p>
                    <span className="font-bold pl-3 pt-3">The People You Were Helping:</span>
                    <ul className="p-3 border-dashed border-b">
                        {peopleForm?.people1.map((el, index) => (
                            <li key={index}>{el.people}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">The People You Will Target:</span>
                    <ul className="p-3 border-dashed border-b">
                        {peopleForm?.people2.map((el, index) => (
                            <li key={index}>{el.target}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Combine:</span>
                    <ul className="p-3">
                        {peopleForm?.combine}
                    </ul>
                </div>
                <div>
                    <p className="p-3 font-bold border-b border-t text-xl">Impact</p>
                    <span className="font-bold pl-3 pt-3">The Benefit People Got From You:</span>
                    <ul className="p-3 border-dashed border-b">
                        {impactForm?.impactBenefit1.map((el, index) => (
                            <li key={index}>{el.impactBenefit}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">The New Benefits:</span>
                    <ul className="p-3 border-dashed border-b">
                        {impactForm?.impactBenefit2.map((el, index) => (
                            <li key={index}>{el.impactBenefit}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Combine:</span>
                    <ul className="p-3">
                        {impactForm?.combine}
                    </ul>
                </div>
                <div>
                    <p className="p-3 font-bold border-b border-t text-xl">Product</p>
                    <span className="font-bold pl-3 pt-3">Products/Services:</span>
                    <ul className="p-3 border-dashed border-b">
                        {productForm?.productService1.map((el, index) => (
                            <li key={index}>{el.productService}</li>
                        ))}
                    </ul>
                    <span className="font-bold pl-3 pt-3">Combine:</span>
                    <ul className="p-3">
                        {productForm?.combine}
                    </ul>
                </div> 
            </div>
        </>
    )
}